export const SOURCE_DATA_TYPES = {
  IMAGE_DATA: 'imageData',
  LANGUAGE: 'language',
  STEPS: 'steps',
  STORAGE_PID: 'storagePid',
  SWITCHABLE_RETURN_TYPES: 'switchableReturnTypes',
  TRANSLATIONS: 'translations',
  USER_DATA: 'userData',
  WORKING_TIME_COMPENSATION: 'workingTimeCompensation',
  USER_FORM_DATA: 'userFormData',
}

export const SOURCE_DATA_CONSTANTS = {
  ADDRESS1: 'Address1',
  ADDRESS2: 'Address2',
  ADDRESS3: 'Address3',
  AGB: 'agb',
  CITY: 'City',
  COMPANY: 'Company',
  COST_TABLE_BATTERY: 'cost_table_battery',
  COST_TABLE_CHARGER: 'cost_table_charger',
  COSTS_HEADER: 'costs_header',
  COSTS_TEXT: 'coststext',
  COUNTRY_ID: 'CountryId',
  DELIVERY_ADDRESSES: 'deliveryAddresses',
  EMAIL: 'Email',
  ENGINE_NOISE_NOTE: 'engine_noise_note',
  ERROR: 'error',
  FIRSTNAME: 'Firstname',
  HEADER: 'header',
  ID: 'Id',
  LANGUAGE_ID: 'LanguageId',
  LASTNAME: 'Lastname',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  MEASURING_SHAFT_NOTE: 'measuring_shaft_note',
  MECHANICAL_DEFECT_NOTE: 'mechanical_defect_note',
  MEMORY_MAGNET_NOTE: 'memory_magnet_note',
  MISFIRE_NOTE: 'misfire_note',
  NO_SUPPORT_NOTE: 'no_support_note',
  PARENT_CUSTOMER_NUMBER: 'parent_customer_number',
  PARENT_ID: 'ParentId',
  // PAYMENT_ADDRESS: 'paymentAddress',
  PAYMENT_ADDRESS_COUNTRY_ID: 'paymentAddressCountryId',
  POSITION: 'Position',
  POSTAL: 'Postal',
  POWER_BREAK_NOTE: 'power_break_note',
  PRIVACY_PID: 'privacy_pid',
  SALUTATION: 'Salutation',
  SAP_ADDRESS_ID: 'SapAddressId',
  SHIFT_SENSOR_NOTE: 'shift_sensor_note',
  SHIPPING_HEADER: 'shipping_header',
  SHIPPING_TEXT: 'shipping_text',
  SITE_ID: 'SiteId',
  SOFTWARE_NOTE: 'software_note',
  STATE: 'State',
  SUB_USER_TYPE: 'sub_user_type',
  TELEFAX: 'Telefax',
  TELEPHONE: 'Telephone',
  TEXT: 'text',
  TICKET_TYPE: 'ticketType',
  TITLE: 'Title',
  TOTAL_FAILURE_NOTE: 'total_failure_note',
  USER_DATA: 'userData',
  USER_NAME: 'username',
  USER_GROUP: 'usergroup',
  VAT_ID: 'VatID',
  WARRANTY_HEADER: 'warranty_header',
  WARRANTY_TEXT: 'warranty_text',
  WEBSITE: 'Website',
  STEPS: {
    CONFIRM: 'confirm',
    ERROR_INFOS: 'errorinfos',
    PRODUCT_INFOS: 'productinfos',
    SUMMARY: 'summary',
  },
  TICKET_TYPES: {
    BATTERY: 'TICKET_TYPE_BATTERY',
    COMPONENT: 'TICKET_TYPE_COMPONENT',
    ENGINE: 'TICKET_TYPE_ENGINE',
    BUY_ENGINE: 'TICKET_TYPE_BUY_ENGINE',
    WORKTIME: 'TICKET_TYPE_WORKTIME',
  },
  USER_FORM_DATA: 'user_form_data',
  SW_BRANDS: 'swBrands',
}

// -> app/public/typo3conf/ext/bu_return_tickets/Classes/Utility/HubspotTicketUtility.php
export const CALCULATION_DESIRE_TYPES = {
  // 'Garantie';
  // 0;
  // engine + battery
  CALCULATION_DESIRE_WARRANTY: 'CALCULATION_DESIRE_WARRANTY',

  // 'Gewährleistung';
  // 1;
  // engine + battery
  CALCULATION_DESIRE_GUARANTEE: 'CALCULATION_DESIRE_GUARANTEE',

  // 'Gewährleistung & Garantie';
  // 2;
  // component
  // Gewährleistung & Garantie':Warranty & guarantee': // EN
  CALCULATION_DESIRE_WARRANTY_AND_GUARANTEE: 'CALCULATION_DESIRE_WARRANTY_AND_GUARANTEE',

  // 'Produkthaftung';
  // 3;
  // engine + battery + component
  // Produkthaftung':Product liability': //EN
  CALCULATION_DESIRE_PRODUCT_LIABILITY: 'CALCULATION_DESIRE_PRODUCT_LIABILITY',

  // 'Transportschaden';
  // 4;
  // component
  // Transportschaden':Transportation damage': //EN
  CALCULATION_DESIRE_TRANSPORTATION_DAMAGE: 'CALCULATION_DESIRE_TRANSPORTATION_DAMAGE',

  // 'Arbeitszeitverguetung';
  // 5;
  // component
  // Arbeitszeitverguetung
  CALCULATION_DESIRE_WORKING_TIME_COMPENSATION: 'CALCULATION_DESIRE_WORKING_TIME_COMPENSATION',

  // 'Kostenpflichtig (175 € zzgl. MwSt)'
  // 2;
  // engine
  CALCULATION_DESIRE_FEE_BASED: 'CALCULATION_DESIRE_FEE_BASED',

  // 'Reparaturauftrag'
  // battery
  CALCULATION_DESIRE_REPAIR_JOB: 'CALCULATION_DESIRE_REPAIR_JOB',

  // Kauf Neumotor
  // 4;
  // engine
  CALCULATION_DESIRE_NEW_ENGINE: 'CALCULATION_DESIRE_NEW_ENGINE',

  // Kauf Poolmotor ohne Abholung Altgerät
  // 4;
  // engine
  CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP:
    'CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP',

  // Kauf Poolmotor mit Abholung Altgerät
  // 5;
  // engine
  CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP:
    'CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP',

  // Kauf Neumotor mit Abholung Altgerät
  // 5;
  // engine
  CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP:
    'CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP',

  // Aufpreis Poolmotor im Gewährleistungszeitraum (statt Reparatur)
  // 1;
  // engine
  CALCULATION_DESIRE_POOL_ENGINE_IN_WARRANTY_PERIOD:
    'CALCULATION_DESIRE_POOL_ENGINE_IN_WARRANTY_PERIOD',

  // Aufpreis Neumotor im Gewährleistungszeitraum (statt Reparatur)
  // 1;
  // engine
  CALCULATION_DESIRE_NEW_ENGINE_IN_WARRANTY_PERIOD:
    'CALCULATION_DESIRE_NEW_ENGINE_IN_WARRANTY_PERIOD',

  // Garantiefall ohne Pickup für noPickupCountries
  // 4;

  // engine
  CALCULATION_DESIRE_WARRANTY_WITHOUT_DEVICE_PICKUP_FOR_NO_PICK_UP_COUNTRIES:
    'CALCULATION_DESIRE_WARRANTY_WITHOUT_DEVICE_PICKUP_FOR_NO_PICK_UP_COUNTRIES',
}

export const ENGINE_TYPES = {
  BACKPEDAL: 'backpedal',
  FREEWHEEL: 'freewheel',
}

export const ORDER_TYPES = {
  WITH_LEGACY_DEVICE_PICK_UP: 'WITH_LEGACY_DEVICE_PICK_UP',
  WITHOUT_LEGACY_DEVICE_PICK_UP: 'WITHOUT_LEGACY_DEVICE_PICK_UP',
}

export const REPAIR_PROCESS_TYPES = {
  POOL: 1,
  REPAIR: 2,
  NEW_ENGINE: 3,
  REPAIR_WITHOUT_PICKUP: 4,
}

export const MODEL_TYPE_DATA_KEYS = {
  IMPULSE: 'impulse',
  IMPULSE_2: 'impulse2',
  IMPLUSE_EVO: 'impulseEVO',
}

export const CALCULATION_DESIRE_TO_REPAIR_PROCESS_TYPE = {
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_WARRANTY]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_GUARANTEE]: REPAIR_PROCESS_TYPES.REPAIR,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_WARRANTY_AND_GUARANTEE]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_PRODUCT_LIABILITY]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_TRANSPORTATION_DAMAGE]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_WORKING_TIME_COMPENSATION]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_FEE_BASED]: REPAIR_PROCESS_TYPES.REPAIR,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_REPAIR_JOB]: null,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_NEW_ENGINE]: REPAIR_PROCESS_TYPES.NEW_ENGINE,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP]:
    REPAIR_PROCESS_TYPES.POOL,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP]:
    REPAIR_PROCESS_TYPES.POOL,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP]:
    REPAIR_PROCESS_TYPES.NEW_ENGINE,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_POOL_ENGINE_IN_WARRANTY_PERIOD]:
    REPAIR_PROCESS_TYPES.POOL,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_NEW_ENGINE_IN_WARRANTY_PERIOD]:
    REPAIR_PROCESS_TYPES.NEW_ENGINE,
  [CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_WARRANTY_WITHOUT_DEVICE_PICKUP_FOR_NO_PICK_UP_COUNTRIES]:
    REPAIR_PROCESS_TYPES.REPAIR_WITHOUT_PICKUP,
}

export const COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS = {
  MODEL_TYPE: {
    MODEL_TYPE_IMPULSE: 'Impulse',
    MODEL_TYPE_IMPULSE_2_0: 'Impulse 2.0',
    MODEL_TYPE_IMPULSE_EVO: 'Impulse EVO',
    MODEL_TYPE_CONTINENTAL: 'Continental',
  },
}

export const COMPLAINT_FORM_COMPONENT = {
  BIKE_SELECTIONS: 'BIKE_SELECTIONS',
  CHECKBOX_SELECTIONS: 'CHECKBOX_SELECTIONS',
}

export const CTDI_DESCRIPTIONS_KEYS = {
  CALCULATION_DESIRE: 'hubspot_calculation_desire',
  ERROR_FREQUENCY: 'error_frequency',
  DAMAGE: 'damage',
  ENGINE_ARTICLE_NO_SAP: 'engine_article_no_sap',
}

export const CONTINENTAL_BIKE_TYPES = {
  1: 'ENDEAVOUR 3.C ADVANCE',
  2: 'ENDEAVOUR 3.C MOVE',
  3: 'IMAGE 3.C ADVANCE',
  4: 'IMAGE 3.C MOVE',
}

export default {
  ELEMENT_ID: 'bu_return_tickets',
  FORM_DATA: 'formData',
  FORM_ERRORS: 'formErrors',
  FORM_PENDING: 'formPending',
  FORM_SUCCESSFUL_SUBMITTED: 'formSuccessfulSubmitted',
  SKIP_STEPS: 'skipSteps',
  FORM_ID: 'complaintForm',
  SOURCE_DATA: 'sourceData',
  STORE_ID: 'complaintForm',
  DATA_TYPES: {
    SOURCE_DATA_TYPES,
  },
  SOURCE_DATA_CONSTANTS,
  CALCULATION_DESIRE_TYPES,
  ENGINE_TYPES,
  ORDER_TYPES,
  REPAIR_PROCESS_TYPES,
  CALCULATION_DESIRE_TO_REPAIR_PROCESS_TYPE,
  COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS,
  CTDI_DESCRIPTIONS_KEYS,
  CONTINENTAL_BIKE_TYPES,
  COMPLAINT_FORM_COMPONENT,

  // Bike data and serial number
  BIKE_COMPONENT_DATA: 'BIKE_COMPONENT_DATA',
}
